export default "__VITE_ASSET__MuehvX8H__"